import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-[6px] border-2 border-forest-ink bg-paper shadow-none focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-forest-ink disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-forest-ink data-[state=checked]:border-forest-ink",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center")}>
      <Check className="h-3.5 w-3.5 text-[#fffefc]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
